import styles from "./radio.module.css";
import { useAppContext } from "@src/autoDebit/AppContext";
import { FieldCommonValue } from "@src/autoDebit/constant";
import Title from "../Title";
import commonStyles from "../common.module.css";

interface IOption {
  label: TranslateDescriptor;
  value: string;
}

export interface IRadioProps extends AutoDebit.IFormField {
  title: TranslateDescriptor;
  option: IOption[];
}

const Radio = ({
  title,
  option,
  id,
  onChange,
  value: controlValue,
  errorComponent,
}: IRadioProps) => {
  const { intl } = useAppContext();

  return (
    <fieldset
      className={commonStyles.wrap}
      key={id}
      data-component={FieldCommonValue}
      data-id={id}
    >
      <Title text={title}></Title>

      <div className={`${commonStyles.action}`}>
        <div className={`${styles.action}`}>
          {option.map(({ value, label }) => {
            const renderLabel = intl.formatMessage(label);

            return (
              <label key={value} className={`${styles.label}`}>
                <input
                  className={styles.radio}
                  name={id}
                  type="radio"
                  value={value}
                  checked={controlValue === value}
                  onChange={(e: React.FormEvent<HTMLInputElement>) => {
                    onChange && onChange(e.currentTarget.value);
                  }}
                />
                <span className={styles.text}>{renderLabel}</span>
              </label>
            );
          })}
        </div>

        {errorComponent && errorComponent()}
      </div>
    </fieldset>
  );
};

export default Radio;
